import isObject from 'lodash/isObject'
import merge from 'lodash/merge'
import reduce from 'lodash/reduce'

import { DataValue } from 'Shared/utils/formData/types'

export const findCaseInsensitiveKey = (obj: Record<string, string[]>, key: string) => {
	return Object.keys(obj).find((k) => k.toLowerCase() === key.toLowerCase())
}

export const flattenObject = <T extends object>({
	obj,
	parentKey = '',
	pathsToPreserve = []
}: {
	obj: T
	parentKey?: string
	pathsToPreserve?: string[]
}): { [key: string]: DataValue } => {
	return reduce(
		obj,
		(result: { [key: string]: DataValue }, value, key) => {
			const newKey = parentKey ? `${parentKey}.${key}` : key
			if (isObject(value) && !pathsToPreserve.includes(newKey)) {
				merge(
					result,
					flattenObject({
						obj: value,
						parentKey: newKey,
						pathsToPreserve: pathsToPreserve
					})
				)
			} else {
				result[newKey] = value
			}
			return result
		},
		{}
	)
}
